import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const auth = async () => {
    const token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// Periode pendaftaran from pmb.t_periode
export const getPeriodeOptions = createAsyncThunk("reportFilter/getPeriode", async () => {
    await auth();
    const response = await jwtAuthAxios.get('v1/periode');
    return response.data;
});

// Distinct jalur pendaftaran
export const getJalurOptions = createAsyncThunk("reportFilter/getJalur", async () => {
    await auth();
    const response = await jwtAuthAxios.get('v1/pendaftar/filter-options');
    return response.data?.jalur || [];
});

// Program studi from pmb.v_detail_program_studi
export const getProdiOptions = createAsyncThunk("reportFilter/getProdi", async () => {
    await auth();
    const response = await jwtAuthAxios.get('v1/program-studi');
    return response.data;
});

const initialState = {
    periodeList: [],
    jalurList: [],
    prodiList: [],
    loadingPeriode: false,
    loadingJalur: false,
    loadingProdi: false,
};

const reportFilterSlice = createSlice({
    name: "reportFilter",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPeriodeOptions.pending, (state) => { state.loadingPeriode = true; })
            .addCase(getPeriodeOptions.fulfilled, (state, action) => { state.periodeList = action.payload; state.loadingPeriode = false; })
            .addCase(getPeriodeOptions.rejected, (state) => { state.loadingPeriode = false; })
            .addCase(getJalurOptions.pending, (state) => { state.loadingJalur = true; })
            .addCase(getJalurOptions.fulfilled, (state, action) => { state.jalurList = action.payload; state.loadingJalur = false; })
            .addCase(getJalurOptions.rejected, (state) => { state.loadingJalur = false; })
            .addCase(getProdiOptions.pending, (state) => { state.loadingProdi = true; })
            .addCase(getProdiOptions.fulfilled, (state, action) => { state.prodiList = action.payload; state.loadingProdi = false; })
            .addCase(getProdiOptions.rejected, (state) => { state.loadingProdi = false; });
    }
});

export const reportFilterSelector = (state) => state.reportFilter;
export default reportFilterSlice.reducer;
